import React from "react";

export function ReviewStar() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
      <path d="M7.72446 1.13982C7.82859 0.898033 8.17141 0.898034 8.27554 1.13982L10.0926 5.35921C10.136 5.46006 10.2311 5.52913 10.3404 5.53927L14.9148 5.96353C15.1769 5.98784 15.2829 6.31388 15.0851 6.48763L11.6337 9.51962C11.5512 9.59209 11.5149 9.70384 11.5391 9.81096L12.5491 14.2926C12.607 14.5494 12.3296 14.7509 12.1033 14.6165L8.15317 12.2709C8.05875 12.2149 7.94125 12.2149 7.84683 12.2709L3.89671 14.6165C3.67035 14.7509 3.393 14.5494 3.45088 14.2926L4.46095 9.81096C4.48509 9.70384 4.44878 9.59209 4.36628 9.51962L0.914909 6.48763C0.717131 6.31388 0.823069 5.98784 1.0852 5.96353L5.65958 5.53927C5.76891 5.52913 5.86398 5.46006 5.90741 5.35921L7.72446 1.13982Z" fill="#FEA500" />
    </svg>
  );
}
